<template>
  <a-modal
    :title="title"
    :visible="visible"
    width="1000px"
    :confirmLoading="confirmLoading"
    :destroyOnClose="true"
    @ok="handleOk"
    @cancel="handleCancel"
    cancelText="关闭"
  >
    <a-spin :spinning="confirmLoading">
      <a-steps :current="statusCurrent">
        <a-step v-for="item in statusDict" :key="item" :title="item" />
      </a-steps>
      <a-descriptions class="descriptions-top" title="反馈详情" bordered>
        <a-descriptions-item label="反馈编号">
          <span class="color-red">{{ fbData.number }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="反馈状态">
          <span class="color-red">{{ fbData.statusCode }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="反馈人">
          {{ fbData.fbUserName }}
        </a-descriptions-item>
        <a-descriptions-item label="部门" :span="2">
          {{ fbData.fbDepartName }}
        </a-descriptions-item>
        <a-descriptions-item label="联系方式">
          {{ fbData.fbUserPhone }}
        </a-descriptions-item>
        <a-descriptions-item label="反馈区域">
          {{ fbData.areaCode_dictText }}
        </a-descriptions-item>
        <a-descriptions-item label="反馈类别">
          {{ fbData.typeCode }}
        </a-descriptions-item>
        <a-descriptions-item label="反馈项目">
          {{ fbData.projectCode }}
        </a-descriptions-item>
        <a-descriptions-item label="内容" :span="3">
          <span class="color-red">{{ fbData.fbContent }}</span>
        </a-descriptions-item>
        <a-descriptions-item label="附图">
          <div class="img-out-div" v-if="fbImgList.length > 0">
            <img
              class="img-width"
              v-for="(item, index) in fbImgList"
              @click="onShowPicture(fbImgList, index)"
              :key="index"
              :src="item"
              :span="3"
            />
          </div>
          <p v-else>没有上传图片</p>
        </a-descriptions-item>
      </a-descriptions>
      <a-descriptions
        v-if="statusCurrent == 1 || statusCurrent == 2"
        class="descriptions-top"
        title="处理详情"
        bordered
      >
        <a-descriptions-item label="处理人">
          {{ fbData.dealUserName }}
        </a-descriptions-item>
        <a-descriptions-item label="部门" :span="2">
          {{ fbData.dealDepartName }}
        </a-descriptions-item>
        <a-descriptions-item :span="3">
          <p slot="label">处理意见<span class="color-red">*</span></p>
          <a-textarea
            :read-only="!isMyselfFb || statusCurrent != 1"
            v-model="dealContentText"
            placeholder="请输入处理意见"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />
        </a-descriptions-item>
        <a-descriptions-item label="附图" :span="3">
          <div v-if="statusCurrent == 1 && isMyselfFb">
            <j-upload
              :uploadAction="uploadAction"
              v-model="uploadImgListValue"
              :max-count="9"
              :is-multiple="true"
            ></j-upload>
          </div>
          <div class="img-out-div" v-else-if="statusCurrent == 2 && dealImgList.length > 0">
            <img
              class="img-width"
              v-for="(item, index) in dealImgList"
              @click="onShowPicture(dealImgList, index)"
              :key="index"
              :src="item"
              :span="3"
            />
          </div>
          <p v-else-if="statusCurrent == 2 && dealImgList.length == 0">没有上传图片</p>
        </a-descriptions-item>
        <a-descriptions-item v-if="statusCurrent == 2 && !fbData.appraiseIs" label="评价">
          暂未评价
        </a-descriptions-item>
        <a-descriptions-item v-if="statusCurrent == 2 && fbData.appraiseIs" label="时效性评价">
          <a-rate :value="fbData.appraiseTimely" :disabled="true" />
        </a-descriptions-item>
        <a-descriptions-item v-if="statusCurrent == 2 && fbData.appraiseIs" label="满意度评价">
          <a-rate :value="fbData.appraiseSatis" :disabled="true" />
        </a-descriptions-item>
      </a-descriptions>
      <p v-if="statusCurrent == 1 && !isMyselfFb" class="color-red text-alingn-center">
        当前反馈已经由{{ this.fbData.dealUserName }}受理，您不能进行提交
      </p>
      <div class="margin-main-btn">
        <a-button type="primary" block v-if="statusCurrent === 0" @click="handleAcceptStart">受理</a-button>
        <a-button type="primary" block v-if="statusCurrent === 1" :disabled="!isMyselfFb" @click="handleAcceptEnd"
          >处理完成</a-button
        >
      </div>
    </a-spin>
    <div class="images" v-viewer="{ movable: false, button: false, navbar: false, title: false, toolbar: false }">
      <img v-show="false" v-for="item in imageListData" :src="item" :key="item" />
    </div>
  </a-modal>
</template>

<script>
import { ajaxGetDictItems, feedbackAcceptance, feedbackProcessingCompleted } from '@/api/api'
import { Descriptions } from 'ant-design-vue'
import JUpload from '@/components/common/JUpload.vue'

export default {
  data() {
    return {
      title: '问题反馈详情',
      confirmLoading: false,
      visible: false,
      fbData: {},
      statusDict: [],
      statusCurrent: 1,
      fbImgList: [],
      imageListData: [],
      dealContentText: '',
      uploadImgListValue: '',
      uploadAction: window._CONFIG['domianURL'] + '/administration/base/feedbackContent/upload',
    }
  },
  methods: {
    open(record) {
      this.fbData = record
      ajaxGetDictItems('administration_feedback_status', null).then((res) => {
        if (res.success) {
          this.statusDict = res.result.map((item) => item.value)
        }
      })
      if (this.fbData.fbImglist) {
        this.fbImgList = this.fbData.fbImglist.split(',')
      } else {
        this.fbImgList = []
      }
      if (this.fbData.dealImglist) {
        this.dealImgList = this.fbData.dealImglist.split(',')
      } else {
        this.dealImgList = []
      }
      if (this.fbData.dealContent) {
        this.dealContentText = this.fbData.dealContent
      } else {
        this.dealContentText = ''
      }
      switch (this.fbData.statusCode) {
        case '待处理':
          this.statusCurrent = 0
          break
        case '处理中':
          this.statusCurrent = 1
          break
        case '已处理':
          this.statusCurrent = 2
          break
        default:
          break
      }
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    onShowPicture(pictList, index) {
      this.imageListData = pictList.slice(index, index + 1)
      const viewer = this.$el.querySelector('.images').$viewer
      viewer.show()
    },
    handleAcceptStart() {
      if (!this.fbData.id) {
        this.$message.error('对不起，找不到主键，请联系开发人员')
        return
      }
      this.$antdConfirm({
        title: '受理?',
        content: '确认受理该反馈吗？',
        onOk: () => {
          feedbackAcceptance({ id: this.fbData.id }).then((res) => {
            if (res.code == 200) {
              this.$message.success('受理成功')
              this.visible = false
              this.$emit('freshen')
              return
            }
            this.$message.error(res.message)
          })
        },
        onCancel: () => {},
      })
    },
    handleAcceptEnd() {
      if (!this.dealContentText) {
        this.$message.error('要进行处理完成操作，请填写处理意见！')
        return
      }
      const submitParams = {
        id: this.fbData.id,
        dealContent: this.dealContentText,
        dealImglist: this.uploadImgListValue,
      }
      feedbackProcessingCompleted(submitParams)
        .then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功！')
            this.visible = false
            this.$emit('freshen')
          } else {
            this.$message.success(res.message)
          }
        })
        .catch((err) => {
          this.$message.error(err.message)
        })
    },
  },
  computed: {
    isMyselfFb() {
      if (this.$store.getters.userInfo.username === this.fbData.dealUserCode) {
        return true
      }
      return false
    },
  },
  components: {
    'a-descriptions': Descriptions,
    'a-descriptions-item': Descriptions.Item,
    JUpload,
  },
}
</script>

<style lang="less" scoped>
.img-out-div {
  display: flex;
  justify-content: flex-start;
  & > :nth-child(n) {
    height: 100px;
    width: auto;
    margin-left: 10px;
  }
}
.color-red {
  color: red;
}
.color-blue {
  color: green;
}
.color-orange {
  color: orange;
}
.descriptions-top {
  margin-top: 20px;
}
.margin-main-btn {
  margin: 10px 300px;
}
.text-alingn-center {
  display: flex;
  justify-content: center;
}
</style>
